import React from 'react';
import {FaDotCircle} from 'react-icons/fa';
import {BsCircle} from 'react-icons/bs';
import {Radio, RadioText, RadioInput} from './styles';
import imageUrl from '../../assets/icons/cards.png';

export default ({
  title,
  name,
  theme,
  id,
  checked = false,
  dynamicActive,
  size = '18px',
  color = 'var(--PrimaryBlue)',
  fontWeight = 400,
}: {
  title: string;
  name: string;
  theme?: string;
  id: string;
  color?: string;
  checked?: boolean;
  size?: string;
  dynamicActive: boolean;
  fontWeight?: number;
}) => (
  <Radio theme={theme}>
    {dynamicActive ? <FaDotCircle color={color} size={size} /> : <BsCircle color="var(--ThirdBlue)" size={size} />}
    <RadioInput type="radio" name={name} id={id} defaultChecked={checked} />
    {id === 'creditCard' ? (
      <img src={imageUrl} style={{width: '185px'}} alt="radioImage" />
    ) : (
      <RadioText style={{color: dynamicActive ? color : '', fontWeight: fontWeight}}>{title}</RadioText>
    )}
  </Radio>
);
